import Service, { getCallApiFunction } from '@/api/service'

type ParamsType = {
  merchantId: number
}

type ResponseType = {
  returnPolicyUrl: string
  stcaUrl: string
}

class FetchMerchantPoliciesApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_MERCHANT_POLICIES'
    this.config = {
      url: `/cms/v1/merchant/${params.merchantId}/policies`,
      method: 'GET',
    }
  }
}

export const fetchMerchantPolicies = (params: ParamsType): Promise<ResponseType> => getCallApiFunction(new FetchMerchantPoliciesApi(params))
